import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 16px;
`;

const Email = styled.div`
  overflow: overlay;
`;

const CustomSelectionHeadCenter = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  margin-left: auto;
`;

const RevertButton = styled(Button)`
  gap: 8px;
`;

const TableName = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 8px;
  overflow: auto;
`;

const SelectAllArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  padding: 8px;
`;

const SelectAllContactButton = styled(Button)`
  font-size: 14px;
  font-weight: 700;
`;

const SelectedContactText = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

const CreateLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
`;

export {
  CreateLabelWrapper,
  CustomSelectionHeadCenter,
  Email,
  RevertButton,
  SelectAllArea,
  SelectAllContactButton,
  SelectedContactText,
  TableName,
  Wrapper
};
